import Parse from "../../../api/ApiConfig";

/**********************
	API functions
**********************/

export const approveMultipleProduct = async (productIds, sessionToken) => {
	const requestHeaders = {
		"X-Parse-Application-Id": "FortCore",
		"X-Parse-Session-Token": `${sessionToken}`,
	};

	let requestBody = { ids: productIds };
	try {
		const response = await fetch(`${Parse.serverURL}/functions/approveProducts`, {
			method: "POST",
			headers: requestHeaders,
			body: JSON.stringify(requestBody),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const addProducts = async (productsData, sessionToken) => {
	const requestHeaders = {
		"X-Parse-Application-Id": "FortCore",
		"X-Parse-Session-Token": `${sessionToken}`,
	};
	try {
		const response = await fetch(`${Parse.serverURL}/functions/addProduct`, {
			method: "POST",
			headers: requestHeaders,
			body: JSON.stringify(productsData),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

/* eslint-disable no-useless-escape */
export const formatInput = (amountValue) => {
	const formattedValue = amountValue.replace(/,/g, "").replace(/[^\d\.]/g, ""); // remove all commas and non-numeric characters
	const parts = formattedValue.split(".");
	const integerPart = parts[0];
	const decimalPart = parts[1] || "";
	const integerDisplayValue = integerPart.replace(/\d(?=(\d{3})+$)/g, "$&,"); // add commas to integer part
	const displayValue = decimalPart ? integerDisplayValue + "." + decimalPart : integerDisplayValue; // add decimal part if present
	return displayValue;
};

export function formatParseDate(dateString) {
	// Create a new Date object from the date string
	const dateObject = new Date(dateString);

	// Format the date to the required format for Parse Server
	const formattedDate = {
		__type: "Date",
		iso: dateObject.toISOString(),
	};

	return formattedDate;
}
